import { useEffect } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _DOCFolder, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useModal, { MODAL_md, MODAL_SM } from "../../../theme/Component/hooks/useModal";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { BasicPage } from "../../../theme/Component/BasicPage";
import usePaginator from "../../../theme/Component/usePaginator";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { toast } from "react-toastify";
import { SelectDOCRepository } from "../DOCRepository/SelectDOCRepository";
import { EditorDOCRepository } from "../DOCRepository/EditorDOCRepository";


interface ComponentData {
    isModal?: boolean;
    _onChange?: Function;
}

export const DOCFolder = ({ isModal, _onChange }: ComponentData) => {

    const { instance, bean, setBean, lista, setLista, addRequiredFields, validateForm, isRequired, isMissing } = useDataBean(_DOCFolder);
    const paginator = usePaginator();

    const modal = useModal("", MODAL_md);
    const modalC = useModal("Eliminar Directorio", MODAL_SM);

    useEffect(() => {
        addRequiredFields(["Code", "Name"])
    }, [])

    useEffect(() => {
        getLista();
    }, [paginator.page])

    const getLista = () => {
        const props = {
            State: 1
        }

        instance.getDOCFolderCatalogPorPropiedades(props, null).then(
            (resp: any) => {
                setLista(resp);
            }
        ).catch(err => {
            toast.error("Error al cargar el listado de Directorios");
        });
    };

    const create = () => {
        setBean({
            State: 1,
            IDEmployee: _single.getAccountID(),

        });
        modal.open("Agregar Directorio");
    }

    const deleteItem = () => {
        const x = { ...bean, State: 2 };
        editaItem(x);
    };

    const editaItem = (obj: any) => {
        if (!validateForm()) {
            toast.error("Faltan Campos Obligatorios por diligenciar");
            return;
        }
        instance.updateDOCFolder(obj).then(
            (resp: any) => {
                getLista();
                modal.close();
                modalC.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const head = [
        { title: 'ID', property: 'IDDOCFolder', visible: true },
        { title: 'Codigo', property: 'Code', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Orden', property: 'OrderNumber', visible: true },
        { title: 'Repositorio', property: '', visible: true },
        { title: 'Ruta', property: 'Path', visible: true },
    ];


    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.open(`Editar Directorio ${bean.Name}`); } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalC.open(); } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const setValue = (e) => {
        _onChange?.(e);
        setBean(e);
    }

    const baseComponent = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <BasicTable
                        body={lista}
                        head={head}
                        rowSet={setValue}
                        listButtons={listaBotones()}
                        iconButtons={iconButtonsItem}
                        records={paginator}
                    />
                </div>
                <div className="col-md-12">

                    <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { editaItem(bean) }}>
                        <div className="row">
                            <div className="col-md-6">
                                <label className={`${isMissing('Code') ? 'has-error' : ''}`}>Codigo {isRequired('Code') ? <span className="text-danger">*</span> : ''}</label>
                                <input className="form-control" type="text" value={bean.Code} onChange={(e) => { setBean({ ...bean, Code: e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${isMissing('Name') ? 'has-error' : ''}`} >Nombre {isRequired('Name') ? <span className="text-danger">*</span> : ''}</label>
                                <input className="form-control" type="text" value={bean.Name} onChange={(e) => { setBean({ ...bean, Name: e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Repositorio</label>
                                <EditorDOCRepository idSelector={bean.IDDOCRepository} onChange={(e) => { setBean({ ...bean, IDDOCRepository: e.IDDOCRepository }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Orden</label>
                                <input type="number" className="form-control" value={bean.OrderNumber} onChange={(e) => { setBean({ ...bean, OrderNumber: e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Ruta</label>
                                <input type="text" className="form-control" value={bean.Path} onChange={(e) => { setBean({ ...bean, Path: e.target.value }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, Description: e.target.value }) }} />
                            </div>
                        </div>
                    </Modal>


                    <ModalConfirm modal={modalC.modal} updateModal={modalC.setModal} eventModal={deleteItem}>
                        <strong>Eliminar Directorio {bean.Name}</strong>
                    </ModalConfirm>
                </div>
            </div>
        )
    }

    return (
        <>
            {isModal ?
                <>
                    {baseComponent()}
                </>
                :
                <BasicPage titulo="Directorios">
                    {baseComponent()}
                </BasicPage>
            }
        </>
    )
}